import { useTranslation } from 'react-i18next';
import { TokenUsageMetrics } from 'features/usage/services/usage-service';
import { formatNumber, getAverage } from 'features/usage/utils/usage-format';
import { UsageSectionLabel } from './usage-section-label';
import { UsageStatCard } from './usage-stat-card';

export function UsageOverview({
  totals,
  periodDays,
  activeDays,
}: {
  totals: TokenUsageMetrics;
  periodDays: number;
  activeDays: number;
}) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <UsageSectionLabel>{t('OVERVIEW')}</UsageSectionLabel>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(12.5rem,1fr))] gap-3">
        <UsageStatCard
          label={t('TOTAL_TOKENS')}
          value={formatNumber(totals.total_tokens)}
          subLabel={t('DAY_WINDOW', { count: periodDays })}
        />
        <UsageStatCard
          label={t('INPUT_TOKENS')}
          value={formatNumber(totals.standard_input_tokens)}
          subLabel={t('AVG_PER_REQ', {
            avg: getAverage(totals.standard_input_tokens, totals.turn_count),
          })}
          valueClassName="text-primary dark:text-true-white"
        />
        <UsageStatCard
          label={t('CACHED_INPUT_TOKENS', { defaultValue: 'Cached Input Tokens' })}
          value={formatNumber(totals.cached_input_tokens)}
          subLabel={t('AVG_PER_REQ', { avg: getAverage(totals.cached_input_tokens, totals.turn_count) })}
          valueClassName="text-primary dark:text-true-white"
        />
        <UsageStatCard
          label={t('CACHE_WRITE_TOKENS', { defaultValue: 'Cache Write Tokens' })}
          value={formatNumber(totals.cache_creation_input_tokens)}
          subLabel={t('AVG_PER_REQ', {
            avg: getAverage(totals.cache_creation_input_tokens, totals.turn_count),
          })}
          valueClassName="text-primary dark:text-true-white"
        />
        <UsageStatCard
          label={t('IMAGE_INPUT_TOKENS', { defaultValue: 'Image Input Tokens' })}
          value={formatNumber(totals.input_image_tokens)}
          subLabel={t('AVG_PER_REQ', {
            avg: getAverage(totals.input_image_tokens, totals.turn_count),
          })}
          valueClassName="text-primary dark:text-true-white"
        />
        <UsageStatCard
          label={t('OUTPUT_TOKENS')}
          value={formatNumber(totals.output_tokens)}
          subLabel={t('AVG_PER_REQ', { avg: getAverage(totals.output_tokens, totals.turn_count) })}
          valueClassName="text-success-green"
        />
        <UsageStatCard
          label={t('IMAGE_OUTPUT_TOKENS', { defaultValue: 'Image Output Tokens' })}
          value={formatNumber(totals.output_image_tokens)}
          subLabel={t('AVG_PER_REQ', {
            avg: getAverage(totals.output_image_tokens, totals.turn_count),
          })}
          valueClassName="text-success-green"
        />
        <UsageStatCard
          label={t('TURNS')}
          value={formatNumber(totals.turn_count)}
          subLabel={t('ACTIVE_DAYS', { count: activeDays })}
        />
        {/* <UsageStatCard
          label={t('MODEL_CALLS')}
          value={formatNumber(totals.model_call_count)}
          subLabel={t('WITHIN_SELECTED_RANGE')}
          valueClassName="text-warning-high-emphasis"
        /> */}
      </div>
    </div>
  );
}
